<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Account Opening</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <h4 slot="heading">
            <span>Overview</span>
            <span class="float-right">
              <span v-if="startDate">
                {{ startDate | moment("dddd, MMMM Do YYYY") }} -
                {{ endDate | moment("dddd, MMMM Do YYYY") }}
              </span>
              <span v-else>{{ today | moment("dddd, MMMM Do YYYY") }}</span>
            </span>
          </h4>
          <p slot="card-1-title">Total No. of Accounts Opened</p>
          <h3 slot="card-1-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalAccountsOpened"
              :options="options"
              @ready="getTotalAccountsOpened"
            />
          </h3>
          <!-- <span slot="card-1-percent">+95%</span>
          <span slot="from" class="grey-color pl_4">from last month</span> -->

          <p slot="card-2-title">Total No. of Funded Accounts</p>
          <h3 slot="card-2-val">
            <ICountUp
              :delay="delay"
              :endVal="totalAccountsFunded"
              :options="options"
              @ready="getTotalAccountsFunded"
            />
          </h3>
          <!-- <span slot="card-2-percent">+69%</span> -->

          <p slot="card-4-earnings">Total Earnings</p>
          <h3 slot="card-4-val">Coming Soon</h3>
          <span></span>
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            type="search"
            placeholder="Search"
            v-model="filter"
            trim
          />
          <b-button slot="search-btn" class="d-none" variant="primary"
            >Search</b-button
          >
          <span slot="entries-no">
            {{ entriesShown }} of {{ totalEntries }} entries
          </span>
          <b-form-datepicker
            slot="start-date"
            id="ao-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="ac-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            :disabled="disabledApply"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table
            slot="table"
            hover
            sticky-header
            :busy="isBusy"
            :filter="filter"
            :per-page="perPage"
            :items="accountsTableData"
            :empty-filtered-html="emptyImg"
            show-empty
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination-nav
            slot="pagination"
            class="d-flex justify-content-end rc-pagination"
            :class="{ 'rc-pagination': rcPagination }"
            :link-gen="linkGen"
            :number-of-pages="totalPages"
            :disabled="isBusy"
            prev-text="Previous"
            next-text="Next"
            use-router
            @change="removeClass"
          ></b-pagination-nav>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-countup-v2";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";

export default {
  name: "AccountOpening",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      filter: "",
      page: "",
      perPage: 20,
      disabled: true,
      disabledApply: true,
      rcPagination: true,
      today: moment(Date.now()).format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.accounts.initialLoad,
      refresh: (state) => state.accounts.refresh,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      isBusy: (state) => state.accounts.loading,
      emptyImg: (state) => state.user.empty,

      totalAccountsOpened: (state) =>
        state.accounts.accountsOverview.totalCount,
      totalAccountsFunded: (state) =>
        state.accounts.accountsOverview.fundedCount,
      // totalaccountEarnings: (state) => state.accounts.accountOverview.earnings,
      totalPages: (state) => state.accounts.accountsTransactions.meta.last_page,
      totalEntries: (state) => state.pos.accountsTransactions.meta.total,
      entriesShown: (state) =>
        state.accounts.accountsTransactions.meta.to !== null
          ? state.accounts.accountsTransactions.meta.to
          : 0,
      accountsTableData: (state) => {
        if (state.accounts.accountsTransactions.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.accounts.accountsTransactions.data;
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      accountsTransactions: "accounts/getAccountsTransactions",
      accountsOverview: "accounts/getAccountsOverview",
    }),
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    getTotalAccountsOpened(instance) {
      const that = this;
      instance.update(that.totalAccountsOpened);
    },
    getTotalAccountsFunded(instance) {
      const that = this;
      instance.update(that.totalAccountsFunded);
    },
    // getTotalAccountEarnings(instance) {
    //   const that = this;
    //   instance.update(that.totalAccountEarnings);
    // },
    getTodayData() {
      this.accountsTransactions({
        startDate: this.today,
        endDate: this.today,
        page: this.page ? this.page : 1,
      });
      this.accountsOverview({
        startDate: this.today,
        endDate: this.today,
      });
    },
    refreshDataOrGotoPage() {
      if (this.startDate.length < 1 && this.endDate.length < 1) {
        this.getTodayData();
      }
      if (this.startDate.length > 1 && this.endDate.length > 1) {
        this.applyFilter();
      }
    },
    applyFilter() {
      this.accountsOverview({
        startDate: this.startDate,
        endDate: this.endDate,
        page: this.page ? this.page : 1,
      });
      this.accountsTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
    removeClass() {
      this.rcPagination = false;
    },
  },
  watch: {
    refresh() {
      if (this.refresh === true) {
        console.log("Refresh Accounts");
        this.refreshDataOrGotoPage();
      }
    },
    "$route.query": {
      handler(query) {
        if (query.page) {
          this.page = query.page;
          this.refreshDataOrGotoPage();
        }
      },
      deep: true,
    },
  },
  created() {
    document.title = "Account Opening | ReadyCash Aggregator Portal";
    this.getTodayData();
  },
};
</script>

<style></style>
